import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-ink grid-lines flex items-center justify-center px-6">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-md border border-white/10 bg-surface p-10 spotlight"
      >
        <p className="font-heading font-black text-2xl text-silver mb-2">
          KLYX<span className="text-mauve">™</span>
        </p>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-300 mb-8 flex items-center gap-2">
          <Lock size={12} /> Studio access
        </p>
        {error && (
          <p data-testid="admin-login-error" className="mb-4 text-sm text-red-400 border border-red-400/30 bg-red-400/5 px-4 py-3">
            {error}
          </p>
        )}
        <input
          data-testid="admin-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="w-full bg-ink border border-white/10 px-4 py-3 text-sm text-silver placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-mauve mb-4"
        />
        <input
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="w-full bg-ink border border-white/10 px-4 py-3 text-sm text-silver placeholder:text-zinc-400 focus:outline-none focus:ring-2 focus:ring-mauve mb-6"
        />
        <button
          data-testid="admin-login-submit"
          disabled={busy}
          className="w-full bg-mauve text-white px-6 py-3 text-xs tracking-[0.2em] uppercase font-bold hover:bg-mauve-dark transition-colors duration-200 disabled:opacity-40"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
